import React from 'react';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react';
import { routes } from '@portal/env/routes';
import { useApp } from '../hooks/useApp';
import { BlogPost } from '@portal/types/nexudus/blog';
import {
  documentToPlainTextString,
  readingTimeForArticle,
} from '@portal/env/utils/textHelpers';
import { ClockIcon } from '@portal/ui/bw-ui/checkout/icons';
import { Card } from '@common/bw-ui/ui/card';

const FeaturedBlogPostCard: React.FC<{ featuredBlogPost: BlogPost }> = observer(
  ({ featuredBlogPost }) => {
    const { resourceImageBaseUrl } = useApp();
    const router = useRouter();

    if (!featuredBlogPost) return null;

    const readingTime = readingTimeForArticle(featuredBlogPost.FullText);
    const summaryTextPlain = documentToPlainTextString(
      featuredBlogPost.SummaryText,
    );

    return (
      <Card
        className="tw:grid tw:grid-cols-1 tw:grid-rows-[auto_1fr] tw:md:grid-cols-2 tw:md:grid-rows-none tw:relative tw:w-full tw:border tw:lg:border-none tw:border-gray-200 tw:overflow-hidden tw:cursor-pointer"
        onClick={() => router.push(routes.post_by_id(featuredBlogPost))}
      >
        <div className="tw:relative tw:w-full tw:aspect-[16/9] tw:rounded-t-lg tw:overflow-hidden tw:md:rounded-l-lg tw:md:rounded-tr-none tw:md:h-full tw:flex-shrink-0">
          <img
            src={`${resourceImageBaseUrl}/blog/getlargeimage?id=${featuredBlogPost.Id}&w=800&h=400&mode=Crop&cache=${featuredBlogPost.UpdatedOn}`}
            alt={featuredBlogPost.Title}
            className="tw:w-full tw:h-full tw:object-cover"
          />
        </div>

        <div className="tw:flex tw:flex-col tw:flex-1 tw:p-4 tw:lg:mt-4">
          <div className="tw:flex tw:flex-col tw:gap-1">
            <span className="tw:bg-red-400 tw:w-fit tw:text-white tw:px-3 tw:md:my-4 tw:py-1 tw:rounded tw:text-xs tw:lg:text-sm tw:font-normal">
              Featured
            </span>
            <h4 className="tw:text-lg tw:lg:text-2xl tw:my-0 tw:font-medium tw:line-clamp-2">
              {featuredBlogPost.Title}
            </h4>
          </div>
          <p className="tw:prose tw:prose-slate tw:max-w-none tw:text-slate-900 tw:text-sm tw:my-2 tw:md:my-4 tw:font-light tw:line-clamp-2">
            {summaryTextPlain}
          </p>
          <div className="tw:flex tw:items-center tw:gap-2 tw:mt-auto tw:mb-4">
            <ClockIcon className="tw:w-4 tw:h-4 tw:text-gray-500" />
            <span className="tw:text-xs tw:text-gray-500 tw:font-light">
              {readingTime.minutes} min read
            </span>
          </div>
        </div>
      </Card>
    );
  },
);

export default FeaturedBlogPostCard;
